import { TCXAccount } from '../../../../interfaces/TCXInterfaces';
import { SnackbarMessageVariants } from '../../../../helpers/enums';
import tcxAccount from '../../../../assets/mockData/tcxAccount';
import { enqueueSnackbar } from '../../notificationActions';

export const RECEIVE_ACCOUNT = 'RECEIVE_ACCOUNT';
export const REQUEST_ACCOUNT_FAILED = 'REQUEST_ACCOUNT_FAILED';
export const REQUEST_ACCOUNT = 'REQUEST_ACCOUNT';

const requestAccount = (): object => {
    return {
        type: REQUEST_ACCOUNT
    };
};

const requestAccountFailed = (): object => {
    return {
        type: REQUEST_ACCOUNT_FAILED
    };
};

const receiveAccount = (page: TCXAccount): object => {
    return {
        type: RECEIVE_ACCOUNT,
        payload: page
    };
};

export const fetchAccount = (): object => {
    return async (dispatch: Function): Promise<void> => {
        dispatch(requestAccount());

        try {
            // TODO: SCHI-703 Remove this mocked Data
            // const account: TCXAccount = await ApiService.get(Endpoints.getAccount, true);
            const account: TCXAccount = await new Promise((resolve) => {
                resolve(tcxAccount);
            });

            if (account.external_reference && account.external_reference.tlr) {
                account.external_ref_parsed = {
                    tlr: JSON.parse(account.external_reference.tlr)
                };
            }

            dispatch(receiveAccount(account));
        } catch (err) {
            dispatch(requestAccountFailed());
            dispatch(enqueueSnackbar({
                message: 'Error occurred while fetching Account.123',
                variant: SnackbarMessageVariants.Error
            }));
        }
    };
};
